import React from "react";

import ThirdTitle from './Titles/ThirdTitle'

const Card = ({
  title,
  description,
  icon,
  className = '',
}) => {
  return (
    <div className={`flex flex-col space-y-6 py-8 justify-center items-center
      text-center rounded-lg transition-all duration-300
      ${className}`} data-aos='fade-up'>

      {/* Icon Container */}
      <div className='flex justify-center items-center w-20 h-20 rounded-lg
        border-2 border-accent-gold/40 bg-accent-gold/5
        group-hover:border-accent-gold group-hover:bg-accent-gold/10
        transition-all duration-300'>
        <span className='text-4xl'>{icon}</span>
      </div>

      {/* Title */}
      <ThirdTitle title={title} className='text-text-primary' />

      {/* Description */}
      <p className="paragraph text-sm sm:text-base md:text-lg lg:text-xl text-text-secondary">
        {description}
      </p>
    </div>
  );
};

export default Card;
